import React from "react";
import Modal from "../../ui/Modal";
import Form from "../../ui/Form";
import { useCreateUserMutation, useUpdateUserMutation } from "../../utils/user.utils";
import { useGetAllRoleQuery } from "../../utils/role.utils";
import { optionGen } from "../../utils/form.utils";

export default function UserAddEdit({ modal, toggle, editItem }) {
  const id = editItem?.id ?? "";
  const isEdit = !!id;

  const { loading: fetchLoading, data } = useGetAllRoleQuery({});

  const roles = optionGen(data ?? []);

  const { loading, createUser } = useCreateUserMutation(["createUser"]);

  const { loading: updating, updateUser } = useUpdateUserMutation(["updateUser"]);

  const fields = [
    {
      label: "Name",
      name: "name",
      type: "text",
      placeholder: "Enter a user name",
      col: { md: 12 },
      rules: { required: "This is required field!" }
    },
    {
      label: "Username",
      name: "username",
      type: "text",
      placeholder: "Enter a username",
      col: { md: 12 },
      rules: { required: "This is required field!" }
    },
    {
      label: "Designation",
      name: "designation",
      type: "text",
      placeholder: "Enter a user designation",
      col: { md: 12 },
    },
    {
      label: "Email",
      name: "email",
      type: "email",
      placeholder: "Enter an email",
      col: { md: 12 },
      rules: { required: "This is required field!" }
    },
    {
      label: "Role",
      name: "role",
      type: "select",
      options: roles,
      placeholder: "Select a role",
      col: { md: 12 }
    },
    {
      label: "Password",
      name: "password",
      type: "password",
      placeholder: "Enter a password",
      col: { md: 12 },
      ...(!isEdit ? { rules: { required: "This is required field!" } } : {})
    }
  ];

  const defaultValues = {
    email: editItem?.email ?? "",
    name: editItem?.name ?? "",
    username: editItem?.username ?? "",
    designation: editItem?.designation ?? "",
    role: editItem?.role?.id ? { label: editItem.role.name, value: editItem.role.id } : ""
  };

  const onSubmit = async (data) => {
    const email = data?.email ?? "";
    const name = data?.name ?? "";
    const password = data?.password ?? "";
    const username = data?.username ?? "";
    const designation = data?.designation ?? "";
    const role_id = data?.role?.value ?? "";

    const values = {
      email,
      name,
      password,
      username,
      designation,
      role_id
    };

    if (isEdit) {
      const afterUpdated = await updateUser({ id, ...values });

      if (afterUpdated?.status === 200) {
        toggle();
      }
      return;
    }

    const afterCreated = await createUser({ ...values });
    if (afterCreated?.status === 201) {
      toggle();
    }
  };

  const isLoading = loading || updating || fetchLoading;

  const title = `${isEdit ? "Update" : "Create"} User`;

  return (
    <Modal modal={modal} toggle={toggle} title={title}>
      <Form
        fields={fields}
        onSubmit={onSubmit}
        defaultValues={defaultValues}
        submitbtnText={isLoading ? `${isEdit ? "Updating..." : "Creating...."}` : title}
        toggle={toggle}
        loading={typeof isLoading === "boolean" ? isLoading : undefined}
      />
    </Modal>
  );
}
